export class EmployeeCountValidator {
  setup() {
    this.validate(this.userEmployeeCount().value);
    this.userEmployeeCount().addEventListener('input', (e) => {
      this.validate(e.target.value);
    });
  }

  userEmployeeCount() {
    return document.getElementById('user_employee_count');
  }

  ramseyPlusMessage() {
    return document.getElementById('ramsey_plus_message');
  }

  validate(employeeCount) {
    if (this.isValidEmployeeCount(employeeCount)) {
      this.enableFields();
      this.hideRamseyPlusMessage();
    } else {
      this.disableFields();
      this.showRamseyPlusMessage();
    }
  }

  enableFields() {
    this.fields().forEach((field) => {
      field.disabled = false;
    });
  }

  disableFields() {
    this.fields().forEach((field) => {
      if (field.id != 'user_employee_count') {
        field.disabled = true;
      }
    });
  }

  hideRamseyPlusMessage() {
    this.ramseyPlusMessage().hidden = true;
  }

  showRamseyPlusMessage() {
    this.ramseyPlusMessage().hidden = false;
  }

  isValidEmployeeCount(employeeCount){
    return employeeCount === '' || parseInt(employeeCount) > 2;
  }

  fields() {
    return document.querySelectorAll(".LeadForm input, .LeadForm textarea, .LeadForm select");
  }
}
